module.exports = __webpack_public_path__ + "media/images/padgett-43ec020d141179e572d2caafe4668650.ico";